module.exports = __webpack_public_path__ + "img/gb9877_1-88-65x95x10.prt.76cea2ce.jpg";